import { useEffect, useMemo, useState } from "react";

type Profile = {
  isMobile: boolean;
  isIOS: boolean;
  isStandalonePWA: boolean;
  openStrategy: "modal" | "newtab";
};

/**
 * Heuristics:
 * - Desktop → modal (keep users in app)
 * - Mobile browsers → new tab
 * - iOS Standalone PWA → modal (avoid Safari handoff)
 */
export function useDeviceProfile(): Profile {
  const [isMobile, setIsMobile] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalonePWA, setIsStandalonePWA] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const uaDataMobile = (navigator as any).userAgentData?.mobile ?? false;
    const iOS = /iPad|iPhone|iPod/i.test(ua);
    const standalone = !!(
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
      (navigator as any).standalone === true
    );
    const coarse = window.matchMedia?.("(pointer: coarse)").matches ?? false;
    const narrow =
      window.matchMedia?.("(max-width: 767px)").matches ?? window.innerWidth < 768;
    const mobile = Boolean(uaDataMobile || coarse || narrow);

    setIsIOS(iOS);
    setIsStandalonePWA(standalone);
    setIsMobile(mobile);
  }, []);

  const openStrategy = useMemo<Profile["openStrategy"]>(() => {
    if (!isMobile) return "modal";
    if (isStandalonePWA) return "modal";
    return "newtab";
  }, [isMobile, isStandalonePWA]);

  return { isMobile, isIOS, isStandalonePWA, openStrategy };
}
